export default {

  create(_, data) {
    return {
      id:           data.id || null, // TODO raus, eigentlich nur für suggestion item
      groupId:      data.groupId || null, // TODO raus, eigentlich nur für suggestion item
      title:        data.title || null,
      actions:      data.actions || null,
      description:  data.description || null,
      href:         data.href || null,
      type:         data.type || null,
      goalId:       data.goalId || null,
      commitmentId: data.commitmentId || null,
      icon:         data.icon || {
        symbol: "clock",
        bgColor: "#5eba00",
        fgColor: "#ffffff"
      },
    }
  },

  fields: {
    title: { validate_bolt_type: 'String' },
    actions: { validate_bolt_type: 'SequenceAction[]' },
    description: { validate_bolt_type: 'String' },
    groupId: { validate_bolt_type: 'Number' },
    id: { validate_bolt_type: 'Number' },
    icon: { validate_bolt_type: 'Object' },
    href: { validate_bolt_type: 'String' }, // TODO -> raus
    type: { validate_bolt_type: 'String' },
    goalId: { validate_bolt_type: 'String' },
    commitmentId: { validate_bolt_type: 'String' },
  }
};
